export const CometChatConfig = {
  APP_ID: '26498050cdb78f67',
  REGION: 'in',
  AUTH_KEY: 'b9d5cc716aa2bf213647948123f25b887fd21f71',
};
